module.exports = __webpack_public_path__ + "static/media/social-icon-x.f155a43c.svg";